export default "__VITE_ASSET__Ba_4kHvF__"